/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateZero = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
var currentDateOne = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateTwo = new Date(new Date().getTime() + 48 * 60 * 60 * 1000);
var currentDateThree = new Date(new Date().getTime() + 72 * 60 * 60 * 1000);
var currentDateFour = new Date(new Date().getTime() + 96 * 60 * 60 * 1000);
var currentDateNew = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
var currentDateCond = new Date(new Date().getTime() + 0 * 60 * 60 * 1000);
var day = currentDateNew.getDate();
let dayN = "th";
switch (day) {
  case 1:
    dayN = ".";
    break;
  case 2:
    dayN = ".";
    break;
  case 3:
    dayN = ".";
    break;
  default:
    dayN = ".";
}
var month = currentDate.getMonth() + 1;
var year = currentDate.getFullYear();
var days = [
  "Søndag",
  "Mandag",
  "Tirsdag",
  "Onsdag",
  "Torsdag",
  "Fredag",
  "Lørdag",
];
const monthNames = [
  "januar",
  "februar",
  "marts",
  "april",
  "maj",
  "juni",
  "juli",
  "august",
  "september",
  "oktober",
  "november",
  "december",
];

function removeLeadingZero(number) {
  number = number.toString();

  if (number === '0' || (number.charAt(0) === '0' && number.length > 1)) {
    number = parseInt(number, 10);
  } else {
    number = parseInt(number, 10);
  }

  return number;
}


function time() {
  var d = new Date();
  var d1 = new Date();
  var hoursOriginal = d.getHours();
  d.setHours(d1.getHours() + 8);
  var hours = 23 - d.getHours();
  var min = 59 - d.getMinutes();
  
  if ((min + "").length == 1) {
    min = "0" + min;
  }
  
  var sec = 59 - d.getSeconds();
  
  if ((sec + "").length == 1) {
    sec = "0" + sec;
  }

  var timeLeft = (removeLeadingZero(hours) > 0 ? removeLeadingZero(hours) + " timer, " : "") + removeLeadingZero(min) + " minutter, " + removeLeadingZero(sec) + " sekunder";
  
  $(".timer").html(
    timeLeft
  );

  if (hoursOriginal >= 15) {
    if ( days[currentDateCond.getDay()] == "Fredag" ) {
      $(".today-tomorrow").html("mandag");
      $(".date-product").html( "Tirsdag, " + currentDateThree.getDate() + dayN + " " + monthNames[currentDateThree.getMonth()] );
    } else if ( days[currentDateCond.getDay()] == "Lørdag" ) {
      $(".today-tomorrow").html("mandag");
      $(".date-product").html( "Tirsdag, " + currentDateTwo.getDate() + dayN + " " + monthNames[currentDateTwo.getMonth()] );
    } else if ( days[currentDateCond.getDay()] == "Søndag" ) {
      $(".today-tomorrow").html("mandag");
      $(".date-product").html( "Tirsdag, " + currentDateOne.getDate() + dayN + " " + monthNames[currentDateOne.getMonth()] );
    } else {
      $(".today-tomorrow").html("i morgen");
      $(".date-product").html( days[currentDateTwo.getDay()] + ", " + currentDateTwo.getDate() + dayN + " " + monthNames[currentDateTwo.getMonth()] );
    }
  } else {
    $(".today-tomorrow").html("i dag");
    $(".date-product").html( days[currentDateNew.getDay()] + ", " + day + dayN + " " + monthNames[currentDateNew.getMonth()] );
  }
}

$( document ).ready(function() {
  time();
  setInterval(time, 1000);
});
